var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 15.5C13.933 15.5 15.5 13.933 15.5 12C15.5 10.067 13.933 8.5 12 8.5C10.067 8.5 8.5 10.067 8.5 12C8.5 13.933 10.067 15.5 12 15.5Z",
    stroke: "#040C1E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3761 11.672C22.2131 10.352 17.5621 5.5 12.0001 5.5C6.43808 5.5 1.78708 10.352 0.624084 11.672C0.54501 11.763 0.501465 11.8795 0.501465 12C0.501465 12.1205 0.54501 12.237 0.624084 12.328C1.78708 13.648 6.43808 18.5 12.0001 18.5C17.5621 18.5 22.2131 13.648 23.3761 12.328C23.4552 12.237 23.4987 12.1205 23.4987 12C23.4987 11.8795 23.4552 11.763 23.3761 11.672V11.672Z",
    stroke: "#040C1E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/Eye.98c80d5edf1c18ceb07668edba96df54.svg";
export { ForwardRef as ReactComponent };